import { useEffect } from 'react';
import SEO from './SEO';
import './TermsAndConditions.css';

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO page="privacy" />
      <div className="terms-page">
        <div className="terms-container">
          <h1 className="terms-title">Privacy Policy</h1>
          <div className="terms-intro">
            <p>Effective August 30, 2026. This policy explains how TapTrap ("the App") handles information in its account-free version.</p>
          </div>

          <div className="terms-content">
            <section className="terms-section">
              <h2>1. Account-Free Use</h2>
              <p>The current App does not ask you to create an account or sign in with Apple or Google. TapTrap does not create a new profile in our database and does not ask for your name or email address to play.</p>
            </section>

            <section className="terms-section">
              <h2>2. Information Stored on Your Device</h2>
              <p>TapTrap stores an installation identifier, onboarding progress and answers, app preferences, downloaded game content, and custom categories on your device. Custom categories are encrypted locally and are not uploaded to TapTrap servers.</p>
              <p>This local information remains on that device until you remove it by deleting the App or clearing its storage. Reinstalling the App may not recover it.</p>
            </section>

            <section className="terms-section">
              <h2>3. Purchases and Anonymous Subscription Identity</h2>
              <p>Purchases are processed by Apple App Store or Google Play and managed in the App through RevenueCat. RevenueCat assigns the installation an anonymous App User ID and processes purchase history, subscription status, product, store, and transaction information needed to provide Premium access.</p>
              <p>TapTrap does not attach a new account name or email address to that anonymous identifier. After reinstalling, you may need to use Restore Purchases with the same store account. Anonymous subscription access is not portable between iOS and Android.</p>
            </section>

            <section className="terms-section">
              <h2>4. Diagnostics and Product Analytics</h2>
              <p>We use Sentry to receive crash reports, error diagnostics, device and app context, and limited session replay data so we can investigate failures. We use Microsoft Clarity to understand app screens, layout, device characteristics, taps, gestures, errors, and reconstructed sessions. These providers apply their own masking, sanitization, security, and retention practices.</p>
              <p>Our public content servers may also receive standard request information such as IP address, app language, app version, request time, and technical logs needed for security and reliability.</p>
            </section>

            <section className="terms-section">
              <h2>5. Historical Accounts from Older Versions</h2>
              <p>Older TapTrap versions allowed Apple or Google sign-in and cloud category storage. We retain those historical account records only for support, legal obligations, and verified deletion requests. They may include name, email, provider identifiers, a historical RevenueCat identifier, authorized devices, cloud categories, and legacy game progress.</p>
              <p>The account-free App does not create or update those records. To request verified deletion of a historical account, visit <a href="https://taptrap.app/delete" className="contact-link">taptrap.app/delete</a>.</p>
            </section>

            <section className="terms-section">
              <h2>6. Service Providers</h2>
              <p>We disclose only the information needed for service operation to Apple or Google for purchases, RevenueCat for subscription management, Sentry for diagnostics, Microsoft Clarity for product analytics, and infrastructure providers that host public content and historical support data. Each provider handles data under its own terms and privacy practices.</p>
            </section>

            <section className="terms-section">
              <h2>7. Deletion and Retention</h2>
              <p>You control information stored locally by deleting the App or clearing its storage. Apple, Google, and RevenueCat retain purchase records according to their legal and operational requirements. Because current installations are anonymous, we may be unable to associate diagnostic or subscription records with an email address.</p>
              <p>Verified historical account deletion removes the legacy account, cloud-created content, game progress, and stored devices from TapTrap systems. We may retain minimal records where required for fraud prevention, legal compliance, or financial recordkeeping.</p>
            </section>

            <section className="terms-section">
              <h2>8. Children's Privacy</h2>
              <p>TapTrap is not designed for children under 17. We do not knowingly collect personal information from children. Contact us if you believe a child provided personal information through a historical account or support request.</p>
            </section>

            <section className="terms-section">
              <h2>9. Security and International Processing</h2>
              <p>We use reasonable technical and organizational safeguards. Service providers may process information in countries other than your own, subject to their applicable safeguards. No system can guarantee absolute security.</p>
            </section>

            <section className="terms-section">
              <h2>10. Policy Updates</h2>
              <p>We may update this policy as the App changes. We will publish the current version here and may provide an in-app notice for material changes.</p>
            </section>

            <section className="terms-section">
              <h2>11. Contact Us</h2>
              <p>For privacy questions, contact <a href="mailto:hi@taptrap.app" className="contact-link">hi@taptrap.app</a>.</p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
